// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31YIB","controls":"styles_controls__1n1xg","charLimit":"styles_charLimit__aAuD2","input":"styles_input__9AOXh","send":"styles_send__apWdz"};